// src/bookings/query/trip-bookings.tsx
import React10 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent } from "@egds/react-core/sheet";
import { gql as gql9, useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";

// src/trip/fragment/booking-details/go-to-trips.tsx
import React4 from "react";
import { EGDSButtonSize } from "@egds/react-core/button";
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-button/egds-button.tsx
import React3 from "react";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React from "react";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { gql } from "@shared-ui/apollo-client-wrapper";
var __EGDSIconFragment = gql`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    title
    theme
    spotLight
  }
`;
var mapSpotlight = spotlight => {
  if (!spotlight) {
    return void 0;
  }
  switch (spotlight) {
    case "STANDARD" /* STANDARD */:
      return "standard";
    case "POSITIVE" /* POSITIVE */:
      return "positive";
    case "WARNING" /* WARNING */:
      return "warning";
    case "INFO" /* INFO */:
      return "info";
    default:
      return void 0;
  }
};
var HelpCenterEGDSIcon = ({
  data,
  size
}) => {
  var _a, _b;
  const iconName = data ? data.id : "";
  const finalSize = size != null ? size : (data == null ? void 0 : data.size) && EGDSIconSize[data.size];
  const spotlight = data == null ? void 0 : data.spotLight;
  const title = (_a = data == null ? void 0 : data.title) != null ? _a : void 0;
  return /* @__PURE__ */React.createElement(EGDSIcon, {
    id: iconName,
    name: iconName,
    size: finalSize,
    title,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0,
    spotlight: mapSpotlight(spotlight)
  });
};
HelpCenterEGDSIcon.displayName = "HelpCenterEGDSIcon";
HelpCenterEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React2 from "react";
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";
var __EGDSGraphicFragment = gql2`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }
  }

  ${HelpCenterEGDSIcon.fragment}
`;
var EGDSGraphic = ({
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React2.createElement(HelpCenterEGDSIcon, {
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// ../internal/src/components/egds-button/egds-button.tsx
var __fragment = gql3`
  fragment EGDSButtonFragment on EGDSButton {
    primary
    disabled
    icon {
      ...EGDSIconFragment
    }
    accessibility
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var HelpCenterEGDSButton = ({
  data,
  onClickHandler,
  isDisabled,
  type,
  iconPosition = "LEADING" /* LEADING */,
  ...otherProps
}) => {
  const {
    primary,
    disabled,
    accessibility,
    __typename,
    icon
  } = data;
  const buttonProps = {
    disabled: disabled || isDisabled,
    title: accessibility,
    type,
    onClick: onClickHandler,
    "aria-label": accessibility || ""
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React3.createElement(EGDSPrimaryButton, {
        ...buttonProps,
        ...otherProps
      }, icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UISecondaryButton":
      return /* @__PURE__ */React3.createElement(EGDSSecondaryButton, {
        ...buttonProps,
        ...otherProps
      }, icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UITertiaryButton":
      return /* @__PURE__ */React3.createElement(EGDSTertiaryButton, {
        ...buttonProps,
        ...otherProps
      }, icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    default:
      return null;
  }
};
HelpCenterEGDSButton.displayName = "HelpCenterEGDSButton";
HelpCenterEGDSButton.fragment = __fragment;

// ../internal/src/utils/constants.ts
var EVENT_TYPE = "Interaction";
var EVENT_VERSION = "1.2.0";
var PAGE_NAME = "Help Articles";
var PAGE_NAME_DETAILED = "Help Articles";
var APP_NAME = "ecp-help-center";
var APP_VERSION = "1.0.0";
var HOME_PAGE = "home_page";
var HELP_CENTER_TRIP_SELECTED = "help_center_trip.selected";
var HELP_CENTER_TRIP_EVENT_CATEGORY = "help_center_trip";

// src/trip/analytics/helper.ts
var buildTrip = analytics => {
  var _a;
  if (analytics.tripDetail && analytics.tripDetail.length > 0) {
    return {
      trip: {
        trip_detail_list: [{
          trip_domain_id: (_a = analytics.tripDetail[0].tripDomainId) != null ? _a : ""
        }]
      }
    };
  }
  return {};
};
var buildWorkFlowList = analytics => {
  var _a;
  if (analytics.workFlowList && analytics.workFlowList.length > 0) {
    const firstWorkFlow = analytics.workFlowList[0];
    const workflow = {
      intent: firstWorkFlow.intent,
      automation_status: firstWorkFlow.automationStatus,
      automation_status_reason: firstWorkFlow.automationStatusReason,
      product_line: firstWorkFlow.productLine,
      order_line_id: (_a = firstWorkFlow.orderLineId) != null ? _a : "",
      channel: firstWorkFlow.channel,
      ...(firstWorkFlow.subIntent && {
        sub_intent: firstWorkFlow.subIntent
      })
    };
    return {
      work_flow_list: {
        work_flow_list: [workflow]
      }
    };
  }
  return {};
};
var buildClickStreamForBookingActions = bookingActionsClickStreamAnalytics => {
  const trip = buildTrip(bookingActionsClickStreamAnalytics);
  const workFlowList = buildWorkFlowList(bookingActionsClickStreamAnalytics);
  return {
    event: {
      event_name: bookingActionsClickStreamAnalytics.event.eventName,
      event_version: bookingActionsClickStreamAnalytics.event.eventVersion,
      event_type: bookingActionsClickStreamAnalytics.event.eventType,
      event_category: bookingActionsClickStreamAnalytics.event.eventCategory,
      ...(bookingActionsClickStreamAnalytics.event.actionLocation && {
        action_location: bookingActionsClickStreamAnalytics.event.actionLocation
      }),
      ...(bookingActionsClickStreamAnalytics.event.actionReason && {
        action_reason: bookingActionsClickStreamAnalytics.event.actionReason
      })
    },
    experience: {
      page_name: bookingActionsClickStreamAnalytics.experience.pageName,
      app_name: bookingActionsClickStreamAnalytics.experience.appName,
      app_version: bookingActionsClickStreamAnalytics.experience.appVersion,
      page_name_detailed: bookingActionsClickStreamAnalytics.experience.pageNameDetailed
    },
    ...workFlowList,
    ...trip
  };
};
var buildClickStreamAnalyticsForTripSelectedEvent = (tripName, numberOfBookings) => {
  return {
    event: {
      event_name: HELP_CENTER_TRIP_SELECTED,
      event_version: EVENT_VERSION,
      event_type: EVENT_TYPE,
      event_category: HELP_CENTER_TRIP_EVENT_CATEGORY,
      action_location: HOME_PAGE
    },
    experience: {
      page_name: PAGE_NAME,
      app_name: APP_NAME,
      app_version: APP_VERSION,
      page_name_detailed: PAGE_NAME_DETAILED
    },
    trip: {
      trip_detail_list: [{
        trip_name: tripName != null ? tripName : "",
        trip_item_count: numberOfBookings.match(/\d+/)[0] ? parseInt(numberOfBookings, 10) : 0
      }]
    }
  };
};

// src/trip/fragment/booking-details/go-to-trips.tsx
var fragment = gql4`
  fragment GoToTripsFragment on UITertiaryButton {
    __typename
    primary
    icon {
      id
      description
      token
      __typename
    }
    action {
      accessibility
      ... on UILinkAction {
        __typename
        resource {
          value
        }
      }
      analytics {
        linkName
        referrerId
      }
      __typename
    }
  }
`;
var GoToTripsButton = ({
  data,
  clickstreamPayload
}) => {
  const trackClick = useEgClickstream();
  const handleClick = () => {
    var _a;
    if (clickstreamPayload) {
      trackClick(buildClickStreamForBookingActions(clickstreamPayload));
    }
    if (((_a = data == null ? void 0 : data.action) == null ? void 0 : _a.__typename) === "UILinkAction" && data.action.resource.value) {
      window.open(data.action.resource.value, "_blank");
    }
  };
  return /* @__PURE__ */React4.createElement(HelpCenterEGDSButton, {
    "aria-label": "go-to-trips",
    "data-testid": "go-to-trips",
    data,
    onClickHandler: handleClick,
    type: "button",
    size: EGDSButtonSize.SMALL
  });
};
GoToTripsButton.fragment = fragment;
GoToTripsButton.displayName = "GoToTripsButton";

// src/bookings/fragment/state/bookings-loading-state.tsx
import React5 from "react";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSFigure, EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing } from "@egds/react-core/spacing";
var BookingsLoadingState = () => {
  return /* @__PURE__ */React5.createElement("div", {
    "data-testid": "loading-state-card"
  }, /* @__PURE__ */React5.createElement(EGDSCard, {
    padded: true,
    border: true
  }, /* @__PURE__ */React5.createElement(EGDSLayoutGrid, {
    autoColumns: ["minmax(var(--uitk-layoutgrid-egds-size__0x), 1fr)"],
    columns: ["1fr", "4fr"],
    space: "three",
    justifyContent: "start",
    alignItems: "start"
  }, /* @__PURE__ */React5.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React5.createElement(EGDSSpacing, {
    margin: {
      blockend: "sixteen"
    }
  }, /* @__PURE__ */React5.createElement(EGDSFigure, {
    ratio: EGDSFigureAspectRatioType.R3_4,
    roundcorner: true
  }, /* @__PURE__ */React5.createElement(EGDSSkeleton, {
    type: "block"
  })))), /* @__PURE__ */React5.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React5.createElement(EGDSLayoutFlex, {
    direction: "column",
    space: "two"
  }, /* @__PURE__ */React5.createElement(EGDSSkeleton, {
    type: "line",
    lineLength: "secondary",
    lineHeight: "type-300"
  }), /* @__PURE__ */React5.createElement(EGDSSkeleton, {
    type: "line",
    lineLength: "primary",
    lineHeight: "heading-6"
  }))))));
};
BookingsLoadingState.displayName = "LoadingState-BookingCards";

// src/bookings/fragment/trip-booking-details/trip-booking-cards.tsx
import React9 from "react";
import { EGDSCard as EGDSCard2 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSParagraph, EGDSText } from "@egds/react-core/text";
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-badge/egds-standard-badge.tsx
import React6 from "react";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-badge/egds-badge-themes-map.ts
var standardBadgeThemesMap = {
  standard: "standard",
  emphasis: "emphasis",
  info: "info",
  featured: "featured",
  brand: "brand",
  warning: "warning",
  positive: "positive"
};

// ../internal/src/components/egds-badge/egds-standard-badge.tsx
var EGDSStandardBadgeFragment__ = gql5`
  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {
    __typename
    text
    theme
    graphic {
      ...EGDSGraphicFragment
    }
  }
  ${EGDSGraphic.fragment}
`;
var HelpCenterEGDSBadge = ({
  data
}) => {
  var _a;
  if (!data.text) {
    return null;
  }
  return /* @__PURE__ */React6.createElement(EGDSBadgeStandard, {
    text: data.text,
    theme: standardBadgeThemesMap[(_a = data.theme) != null ? _a : "standard"]
  }, data.graphic && /* @__PURE__ */React6.createElement(EGDSGraphic, {
    data: data.graphic
  }));
};
HelpCenterEGDSBadge.displayName = "HelpCenterEGDSBadge";
HelpCenterEGDSBadge.fragment = EGDSStandardBadgeFragment__;

// src/bookings/fragment/booking-action-cards/booking-actions.tsx
import React7 from "react";
import { EGDSButtonSize as EGDSButtonSize2 } from "@egds/react-core/button";
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { useSignalPublisher } from "@shared-ui/core-signal-manager/context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useVirtualAgentContext } from "@shared-ui/retail-help-center-util";
import { VacCreateConversationSignal, VirtualAgentControlMessageType } from "@shared-ui/retail-signals-virtual-agent";

// src/trip/analytics/clickstream-analytics.ts
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
var BookingActionsClickStreamAnalyticsFragment = gql6`
  fragment BookingActionsClickStreamAnalyticsFragment on BookingActionsClickStreamAnalytics {
    event {
      eventName
      eventType
      eventCategory
      eventVersion
      actionLocation
      actionReason
      __typename
    }
    tripDetail {
      tripDomainId
      __typename
    }
    experience {
      pageName
      appName
      appVersion
      pageNameDetailed
      __typename
    }
    workFlowList {
      intent
      orderLineId
      productLine
      subIntent
      automationStatus
      automationStatusReason
      channel
      __typename
    }
    __typename
  }
`;

// src/bookings/fragment/booking-action-cards/booking-actions.tsx
var fragment2 = gql7`
  fragment BookingActionFragment on BookingActionButton {
    ... on HelpCenterIntentButtons {
      name {
        ...EGDSButtonFragment
      }
      skillName
      vaText
      payload
      bookingActionsClickStreamAnalytics {
        ...BookingActionsClickStreamAnalyticsFragment
      }
      __typename
    }
    ... on HelpCenterBookingActionButton {
      name {
        ...EGDSButtonFragment
      }
      action {
        ... on UILinkAction {
          accessibility
          resource {
            value
          }
        }
      }
      bookingActionsClickStreamAnalytics {
        ...BookingActionsClickStreamAnalyticsFragment
      }
      __typename
    }
  }
  ${HelpCenterEGDSButton.fragment}
  ${BookingActionsClickStreamAnalyticsFragment}
`;
var BookingAction = ({
  data,
  closeSideSheet
}) => {
  const {
    controller
  } = useVirtualAgentContext();
  const trackClick = useEgClickstream2();
  const isSharedUIHelpCenter = useExperiment("Shared_UI_VAC_Web_HelpCenter").exposure.bucket === 1;
  const {
    publish
  } = useSignalPublisher();
  const handleBookingActionClick = () => {
    var _a, _b;
    if (data.__typename === "HelpCenterIntentButtons") {
      const message = {
        conversationAttributes: [{
          key: "launchPoint",
          value: "FAB"
        }, {
          key: "pageName",
          value: "Help Articles"
        }, {
          key: "conversationType",
          value: "main"
        }],
        intentData: {
          messageType: VirtualAgentControlMessageType.POSTBACK,
          intent: data.skillName,
          text: data.vaText || ""
        },
        silent: false
      };
      if (isSharedUIHelpCenter) {
        const signal = new VacCreateConversationSignal("VAC_IBM_CREATE_CONVERSATION", message);
        publish(signal);
      } else {
        const fallbackMessage = {
          text: data.vaText,
          messageType: "POSTBACK",
          intent: data.skillName
        };
        if (data.payload) {
          fallbackMessage.payload = data.payload;
          controller.sendMessage(fallbackMessage);
        }
      }
      if (data.bookingActionsClickStreamAnalytics) {
        trackClick(buildClickStreamForBookingActions(data.bookingActionsClickStreamAnalytics));
      }
    } else if (data.__typename === "HelpCenterBookingActionButton") {
      if (data.bookingActionsClickStreamAnalytics) {
        trackClick(buildClickStreamForBookingActions(data.bookingActionsClickStreamAnalytics));
      }
      const resource = (_b = (_a = data.action) == null ? void 0 : _a.resource) == null ? void 0 : _b.value;
      if (resource) {
        window.open(resource, "_blank");
      }
    }
    closeSideSheet();
  };
  const buttonData = data.__typename === "HelpCenterIntentButtons" || data.__typename === "HelpCenterBookingActionButton" ? {
    ...data.name,
    __typename: "UISecondaryButton"
  } : {
    __typename: "UISecondaryButton",
    primary: null,
    disabled: false,
    accessibility: null,
    icon: null
  };
  return /* @__PURE__ */React7.createElement(HelpCenterEGDSButton, {
    data: buttonData,
    type: "button",
    size: EGDSButtonSize2.SMALL,
    onClickHandler: handleBookingActionClick
  });
};
BookingAction.fragment = fragment2;
BookingAction.displayName = "IntentButtons";

// src/bookings/fragment/booking-action-cards/booking-action-menu.tsx
import React8 from "react";
import { EGDSButtonSize as EGDSButtonSize3 } from "@egds/react-core/button";
import { EGDSMenu, EGDSMenuContainer, EGDSMenuList, EGDSMenuTrigger, PositionType } from "@egds/react-core/menu";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { useVirtualAgentContext as useVirtualAgentContext2 } from "@shared-ui/retail-help-center-util";
var BookingActionMenu = ({
  data,
  maxActionsToShow,
  closeSideSheet
}) => {
  const {
    controller
  } = useVirtualAgentContext2();
  const trackClick = useEgClickstream3();
  const [isMenuOpen, setIsMenuOpen] = React8.useState(false);
  const handleMenuClick = () => setIsMenuOpen(!isMenuOpen);
  const menuItems = data.bookingActions ? data.bookingActions.slice(maxActionsToShow).map((item, i) => {
    var _a, _b, _c, _d;
    const isBookingActionWithResource = item.__typename === "HelpCenterBookingActionButton" && ((_b = (_a = item.action) == null ? void 0 : _a.resource) == null ? void 0 : _b.value);
    return {
      attributes: {
        role: "menuitem",
        tabindex: i
      },
      className: "uitk-list-item",
      label: item.name.primary,
      typeAnchor: isBookingActionWithResource,
      href: isBookingActionWithResource ? (_d = (_c = item.action) == null ? void 0 : _c.resource) == null ? void 0 : _d.value : void 0,
      target: isBookingActionWithResource ? "_blank" : void 0,
      rel: isBookingActionWithResource ? "noopener noreferrer" : void 0,
      onClick: async () => {
        if (item.__typename === "HelpCenterIntentButtons") {
          const message = {
            text: item.vaText,
            messageType: "POSTBACK",
            intent: item.skillName
          };
          if (item.payload) {
            message.payload = item.payload;
            controller.sendMessage(message);
          }
        }
        if (item.bookingActionsClickStreamAnalytics) {
          trackClick(buildClickStreamForBookingActions(item.bookingActionsClickStreamAnalytics));
        }
        closeSideSheet();
      }
    };
  }) : [];
  return /* @__PURE__ */React8.createElement(EGDSMenu, {
    isOpen: isMenuOpen,
    onTriggerClick: handleMenuClick
  }, data.bookingActions && data.bookingActions.length > maxActionsToShow && /* @__PURE__ */React8.createElement(EGDSMenuTrigger, null, /* @__PURE__ */React8.createElement(HelpCenterEGDSButton, {
    type: "button",
    size: EGDSButtonSize3.SMALL,
    data: {
      primary: data.viewMoreOptionsText,
      accessibility: null,
      __typename: "UITertiaryButton",
      icon: null,
      disabled: false
    }
  })), /* @__PURE__ */React8.createElement(EGDSMenuContainer, {
    position: PositionType.LEFT
  }, /* @__PURE__ */React8.createElement(EGDSMenuList, {
    items: menuItems
  })));
};
BookingActionMenu.displayName = "BookingActionMenu";

// src/bookings/fragment/trip-booking-details/trip-booking-cards.tsx
var fragment3 = gql8`
  fragment TripBookingsFragment on BookingDetail {
    viewMoreOptionsText
    timePeriod
    itineraryNumberText
    title
    image {
      url
      description
    }
    product
    bookingActions {
      ...BookingActionFragment
    }
    bookingBadges {
      ...EGDSStandardBadgeFragment
    }
    unavailableMessage
    __typename
  }
  ${BookingAction.fragment}
  ${HelpCenterEGDSBadge.fragment}
`;
var TripBookingCards = ({
  data,
  closeSideSheet
}) => {
  var _a;
  const maxActionsToShow = data.unavailableMessage ? 1 : 2;
  const showMenuThreshold = data.unavailableMessage ? 2 : 3;
  return /* @__PURE__ */React9.createElement(EGDSCard2, {
    padded: true,
    border: true,
    overflow: true
  }, /* @__PURE__ */React9.createElement(EGDSLayoutGrid2, {
    autoColumns: ["minmax(var(--uitk-layoutgrid-egds-size__0x), 1fr)"],
    columns: ["1fr", "4fr"],
    space: "three"
  }, /* @__PURE__ */React9.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React9.createElement(EGDSFigure2, {
    ratio: EGDSFigureAspectRatioType2.R3_4,
    roundcorner: true
  }, /* @__PURE__ */React9.createElement(EGDSImage, {
    alt: data.image ? data.image.description : "alternative text",
    placeholderImage: true,
    src: data.image ? data.image.url : "true"
  }))), /* @__PURE__ */React9.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    direction: "column",
    space: "small"
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    space: "two"
  }, (_a = data == null ? void 0 : data.bookingBadges) == null ? void 0 : _a.map((el, i) => /* @__PURE__ */React9.createElement(HelpCenterEGDSBadge, {
    key: i,
    data: el
  }))), /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    direction: "column",
    space: "one"
  }, data.product === "Activity" || data.product === "Car" ? /* @__PURE__ */React9.createElement(React9.Fragment, null, /* @__PURE__ */React9.createElement(EGDSHeading, {
    tag: "h3",
    size: 6
  }, data.title.split("::")[0]), /* @__PURE__ */React9.createElement(EGDSHeading, {
    tag: "h3",
    size: 6
  }, data.title.split("::")[1])) : /* @__PURE__ */React9.createElement(EGDSHeading, {
    tag: "h3",
    size: 6
  }, data.title), /* @__PURE__ */React9.createElement(EGDSText, {
    size: 300
  }, data.timePeriod), /* @__PURE__ */React9.createElement(EGDSText, {
    size: 300
  }, data.itineraryNumberText))))), data.unavailableMessage && /* @__PURE__ */React9.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React9.createElement("div", {
    "data-stid": "help-center-booking-cards-unavailable-message",
    style: {
      borderRadius: "8px",
      padding: "12px",
      background: "#EFF3F7",
      gap: "4px"
    }
  }, /* @__PURE__ */React9.createElement(EGDSParagraph, null, data.unavailableMessage))), /* @__PURE__ */React9.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "three",
      blockend: "two"
    }
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    direction: "column",
    space: "medium"
  }, (data.bookingActions.length === showMenuThreshold ? data.bookingActions : data.bookingActions.slice(0, maxActionsToShow)).map((action, index1) => /* @__PURE__ */React9.createElement(EGDSCard2, {
    key: index1
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem, null, (action.__typename === "HelpCenterIntentButtons" || action.__typename === "HelpCenterBookingActionButton") && /* @__PURE__ */React9.createElement(BookingAction, {
    data: action,
    closeSideSheet
  })))))), data.bookingActions && data.bookingActions.length > showMenuThreshold && /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    justifyContent: "center"
  }, /* @__PURE__ */React9.createElement(BookingActionMenu, {
    data,
    maxActionsToShow,
    closeSideSheet
  })));
};
TripBookingCards.fragment = fragment3;
TripBookingCards.displayName = "BookingCards";

// src/bookings/query/trip-bookings.tsx
var __Query = gql9`
  query HelpCenterTripBookingQuery($context: ContextInput!, $tripId: String!) {
    helpCenterPersonalization(context: $context, tripId: $tripId) {
      helpCenterBookingView {
        timePeriod
        header
        tripBookings {
          ...TripBookingsFragment
        }
        goToTrips {
          ...GoToTripsFragment
        }
      }
    }
  }
  ${TripBookingCards.fragment}
  ${GoToTripsButton.fragment}
`;
var TripBookings = ({
  ssr = false,
  bookingPayload = {
    timePeriod: "",
    tripId: "",
    tripName: ""
  },
  closeSideSheet
}) => {
  const {
    tripId,
    tripName,
    timePeriod
  } = bookingPayload;
  const {
    context
  } = useBexApi();
  const variables = {
    context,
    tripId: tripId != null ? tripId : ""
  };
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr
  });
  const renderContent = isLoading => {
    var _a, _b, _c, _d, _e;
    const commonContent = /* @__PURE__ */React10.createElement(EGDSSheetContent, null, /* @__PURE__ */React10.createElement(EGDSLayoutFlex3, {
      direction: "column",
      space: "six"
    }, isLoading ? [...Array(2)].map((_, index) => /* @__PURE__ */React10.createElement(BookingsLoadingState, {
      key: index
    })) : (_c = (_b = (_a = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _a.helpCenterBookingView) == null ? void 0 : _b.tripBookings) == null ? void 0 : _c.map((booking, index) => /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem2, {
      key: index
    }, booking.__typename === "BookingDetail" && /* @__PURE__ */React10.createElement(TripBookingCards, {
      data: booking,
      closeSideSheet
    }))), /* @__PURE__ */React10.createElement(EGDSLayoutFlex3, null, /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem2, null, ((_e = (_d = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _d.helpCenterBookingView) == null ? void 0 : _e.goToTrips) && /* @__PURE__ */React10.createElement(GoToTripsButton, {
      "data-testid": "go-to-trips",
      data: data.helpCenterPersonalization.helpCenterBookingView.goToTrips
    })))));
    return commonContent;
  };
  if (loading) {
    return renderContent(true);
  }
  if (error || !data) {
    return null;
  }
  return renderContent(false);
};
TripBookings.displayName = "sharedui-Tripbookings";

// src/trip/query/tripmtwo.tsx
import React17, { useState } from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSheet, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSTab, EGDSTabs, EGDSTabsBackGroundColorType, EGDSTabsType } from "@egds/react-core/tabs";
import { EGDSHeading as EGDSHeading4, EGDSText as EGDSText4 } from "@egds/react-core/text";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { gql as gql15, useQuery as useQuery2 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";

// src/trip/fragment/state/empty-state.tsx
import React13 from "react";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSParagraph as EGDSParagraph2, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";

// src/trip/fragment/state/existing-booking-button.tsx
import React11 from "react";
import { EGDSButtonSize as EGDSButtonSize4 } from "@egds/react-core/button";
import { gql as gql10 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
import { useVirtualAgentContext as useVirtualAgentContext3 } from "@shared-ui/retail-help-center-util";
var fragment4 = gql10`
  fragment ExistingBookingButtonFragment on HelpCenterIntentButtons {
    name {
      ...EGDSButtonFragment
      __typename
    }
    skillName
    vaText
    payload
    bookingActionsClickStreamAnalytics {
      ...BookingActionsClickStreamAnalyticsFragment
    }
    __typename
  }
  ${HelpCenterEGDSButton.fragment}
  ${BookingActionsClickStreamAnalyticsFragment}
`;
var ExistingBookingButton = ({
  data,
  ...props
}) => {
  const {
    controller
  } = useVirtualAgentContext3();
  const trackClick = useEgClickstream4();
  const bookingActions = data.bookingActionsClickStreamAnalytics;
  const handleClick = async () => {
    const message = {
      text: data.vaText,
      messageType: "POSTBACK",
      intent: data.skillName
    };
    if (data.payload) {
      message.payload = data.payload;
      controller.sendMessage(message);
    }
    if (bookingActions) {
      trackClick(buildClickStreamForBookingActions(bookingActions));
    }
  };
  return /* @__PURE__ */React11.createElement(HelpCenterEGDSButton, {
    type: "button",
    ...props,
    data: data.name,
    size: EGDSButtonSize4.MEDIUM,
    onClickHandler: handleClick
  });
};
ExistingBookingButton.fragment = fragment4;
ExistingBookingButton.displayName = "ExistingBookingButton";

// src/trip/fragment/state/start-shopping-button.tsx
import React12 from "react";
import { EGDSButtonSize as EGDSButtonSize5 } from "@egds/react-core/button";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";
var fragment5 = gql11`
  fragment StartShoppingButtonFragment on UITertiaryButton {
    primary
    disabled
    accessibility
    icon {
      ...EGDSIconFragment
    }
    __typename
    action {
      ... on UILinkAction {
        __typename
        resource {
          value
        }
      }
    }
  }
  ${HelpCenterEGDSButton.fragment}
`;
var StartShoppingButton = ({
  data,
  ...props
}) => {
  const handleClick = () => {
    var _a;
    const action = data == null ? void 0 : data.action;
    if ((action == null ? void 0 : action.__typename) === "UILinkAction" && ((_a = action.resource) == null ? void 0 : _a.value)) {
      window.location.href = action.resource.value;
    }
  };
  return /* @__PURE__ */React12.createElement(HelpCenterEGDSButton, {
    data: {
      ...data,
      __typename: data.__typename
    },
    size: EGDSButtonSize5.MEDIUM,
    onClickHandler: handleClick,
    type: "button",
    ...props,
    "data-stid": "start-shopping-button"
  });
};
StartShoppingButton.fragment = fragment5;
StartShoppingButton.displayName = "StartShoppingButton";

// src/trip/fragment/state/empty-state.tsx
var fragment6 = gql12`
  fragment EmptyStateFragment on EmptyState {
    illustration {
      url
      description
      egdsElementId
      id
    }
    text
    existingBooking {
      ...ExistingBookingButtonFragment
    }
    startShopping {
      ...StartShoppingButtonFragment
    }
  }
  ${ExistingBookingButton.fragment}
  ${StartShoppingButton.fragment}
`;
var EmptyState = ({
  data
}) => {
  var _a, _b;
  return /* @__PURE__ */React13.createElement(EGDSLayoutFlex4, {
    justifyContent: "center",
    alignItems: "center",
    direction: "column",
    blockSize: "full_size",
    "data-testid": "empty-state"
  }, /* @__PURE__ */React13.createElement(EGDSLayoutFlex4, {
    direction: "column",
    alignItems: "center",
    space: "four"
  }, /* @__PURE__ */React13.createElement(EGDSSpacing3, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React13.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React13.createElement(EGDSIllustrations, {
    alt: ((_a = data == null ? void 0 : data.illustration) == null ? void 0 : _a.description) || "",
    url: (_b = data == null ? void 0 : data.illustration) == null ? void 0 : _b.url
  }))), /* @__PURE__ */React13.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React13.createElement(EGDSParagraph2, null, /* @__PURE__ */React13.createElement(EGDSText2, {
    align: "center"
  }, data == null ? void 0 : data.text))), /* @__PURE__ */React13.createElement(EGDSLayoutFlexItem3, null, (data == null ? void 0 : data.existingBooking) && /* @__PURE__ */React13.createElement(ExistingBookingButton, {
    data: data.existingBooking,
    "data-testid": "intent-button-primary"
  })), /* @__PURE__ */React13.createElement(EGDSLayoutFlexItem3, null, (data == null ? void 0 : data.startShopping) && /* @__PURE__ */React13.createElement(StartShoppingButton, {
    data: data == null ? void 0 : data.startShopping,
    "data-testid": "start-shopping-button"
  })), /* @__PURE__ */React13.createElement(EGDSSpacing3, {
    padding: {
      blockend: "four"
    }
  })));
};
EmptyState.fragment = fragment6;
EmptyState.displayName = "EmptyState";

// src/trip/fragment/state/loading-state.tsx
import React14 from "react";
import { EGDSCard as EGDSCard3, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSSkeleton as EGDSSkeleton2 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
var LoadingState = () => {
  const skeletonCards = Array.from({
    length: 3
  });
  return /* @__PURE__ */React14.createElement(EGDSSpacing4, {
    padding: {
      blockstart: "three",
      blockend: "three"
    }
  }, /* @__PURE__ */React14.createElement("div", {
    "data-testid": "loading-state-grid"
  }, /* @__PURE__ */React14.createElement(EGDSLayoutGrid3, {
    columns: ["repeat(auto-fit, 327px)"],
    space: "medium",
    justifyContent: "center"
  }, skeletonCards.map((_, index) => /* @__PURE__ */React14.createElement(EGDSLayoutGridItem3, {
    key: `loading-${index}`
  }, /* @__PURE__ */React14.createElement("div", {
    "data-testid": `loading-card-${index}`
  }, /* @__PURE__ */React14.createElement(EGDSCard3, {
    style: {
      minHeight: "152px"
    }
  }, /* @__PURE__ */React14.createElement(EGDSCardContentSection, {
    padded: false
  }, /* @__PURE__ */React14.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React14.createElement("div", {
    "data-testid": `loading-skeleton-${index}`
  }, /* @__PURE__ */React14.createElement(EGDSSkeleton2, {
    cornerRadius: 1,
    type: "block",
    color: "007BFF"
  })))))))))));
};
var loading_state_default = LoadingState;

// src/trip/fragment/trip-category/trip-category-pill.tsx
import React16 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4, MinMax } from "@egds/react-core/layout-grid";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3 } from "@egds/react-core/text";
import { gql as gql14 } from "@shared-ui/apollo-client-wrapper";

// src/trip/fragment/trip-category/trip-info-card.tsx
import React15 from "react";
import { EGDSBadgeStandard as EGDSBadgeStandard2 } from "@egds/react-core/badge";
import { EGDSCard as EGDSCard4, EGDSCardContentSection as EGDSCardContentSection2, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon2, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSFigure as EGDSFigure3, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSScrim, EGDSScrimType } from "@egds/react-core/scrim";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText3 } from "@egds/react-core/text";
import { gql as gql13 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream5 } from "@shared-ui/clickstream-analytics-context";
var fragment7 = gql13`
  fragment HelpCenterTripInfoWithYearFragment on HelpCenterTripInfo {
    backToTripButton
    header
    tripId
    tripName
    image {
      description
      url
      __typename
    }
    timePeriod
    yearOfTrip
    numberOfBooking
    bookingIcons {
      id
      __typename
    }
    __typename
  }
`;
var HelpCenterTripInfoCard = ({
  data,
  onSelect,
  selected,
  openSheet
}) => {
  const trackClick = useEgClickstream5();
  const handleCardClick = () => {
    onSelect == null ? void 0 : onSelect();
    trackClick(buildClickStreamAnalyticsForTripSelectedEvent(data.tripName, data.numberOfBooking));
  };
  const figureContent = trip => {
    var _a, _b, _c;
    return /* @__PURE__ */React15.createElement(React15.Fragment, null, /* @__PURE__ */React15.createElement(EGDSImage2, {
      placeholderImage: true,
      alt: (_a = trip == null ? void 0 : trip.image) == null ? void 0 : _a.description,
      src: (_b = trip == null ? void 0 : trip.image) == null ? void 0 : _b.url
    }), /* @__PURE__ */React15.createElement(EGDSScrim, {
      type: EGDSScrimType.OVERLAY
    }, /* @__PURE__ */React15.createElement(EGDSCardContentSection2, null, /* @__PURE__ */React15.createElement(EGDSSpacing5, {
      padding: {
        blockstart: "six",
        inlineend: "two",
        blockend: "one",
        inlinestart: "two"
      }
    }, /* @__PURE__ */React15.createElement(EGDSLayoutFlex5, {
      direction: "column",
      justifyContent: "space-between",
      space: "one"
    }, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem4, null, (trip == null ? void 0 : trip.bookingIcons) !== null && ((_c = trip == null ? void 0 : trip.bookingIcons) == null ? void 0 : _c.length) > 0 && /* @__PURE__ */React15.createElement(EGDSLayoutFlex5, {
      space: "two"
    }, trip == null ? void 0 : trip.bookingIcons.map((el, i) => /* @__PURE__ */React15.createElement(EGDSBadgeStandard2, {
      key: i,
      theme: "standard",
      className: "egds-badge"
    }, /* @__PURE__ */React15.createElement(EGDSIcon2, {
      name: el.id,
      size: EGDSIconSize2.SMALL,
      "data-icon-name": el.id,
      className: "egds-icon"
    }))))), /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React15.createElement(EGDSHeading2, {
      tag: "h4",
      size: 4,
      typeStyle: {
        customStyle: "headline-large"
      },
      overflow: "truncate"
    }, trip.tripName)), /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React15.createElement(EGDSText3, {
      className: "egds-text"
    }, trip.timePeriod)))))));
  };
  return /* @__PURE__ */React15.createElement(EGDSSpacing5, null, /* @__PURE__ */React15.createElement(EGDSCard4, {
    "data-stid": "trip-info-card-overview",
    className: selected ? "egds-card--selected" : void 0,
    onClick: handleCardClick
  }, /* @__PURE__ */React15.createElement("div", {
    "data-ratio": "21:9",
    className: "egds-figure"
  }, /* @__PURE__ */React15.createElement(EGDSFigure3, {
    ratio: EGDSFigureAspectRatioType3.R21_9
  }, figureContent(data))), /* @__PURE__ */React15.createElement(EGDSCardLink, null, /* @__PURE__ */React15.createElement("button", {
    "data-stid": "trip-bookings-button",
    onClick: () => {
      openSheet(data.tripId, data.tripName, data.timePeriod);
      onSelect == null ? void 0 : onSelect();
      trackClick(buildClickStreamAnalyticsForTripSelectedEvent(data.tripName, data.numberOfBooking));
    },
    type: "button"
  }, data.tripName))));
};
HelpCenterTripInfoCard.fragment = fragment7;
HelpCenterTripInfoCard.displayName = "TripInfoCard";

// src/trip/fragment/trip-category/trip-category-pill.tsx
var fragment8 = gql14`
  fragment TripCategoryPillFragment on TripCategory {
    header
    tabTitle
    tripInfos {
      ...HelpCenterTripInfoWithYearFragment
      timePeriod
      yearOfTrip
    }
  }
  ${HelpCenterTripInfoCard.fragment}
`;
var TripCategoryPill = ({
  data,
  selected,
  openSheet
}) => {
  var _a, _b;
  const groupedTrips = React16.useMemo(() => {
    if (!(data == null ? void 0 : data.tripInfos) || (data == null ? void 0 : data.tabTitle.toLowerCase()) !== "past" && (data == null ? void 0 : data.tabTitle.toLowerCase()) !== "canceled") {
      return null;
    }
    const groups = data.tripInfos.reduce((acc, trip) => {
      if (!(trip == null ? void 0 : trip.yearOfTrip)) {
        return acc;
      }
      const year = trip.yearOfTrip;
      if (!acc[year]) {
        acc[year] = [];
      }
      acc[year] = [...acc[year], trip];
      return acc;
    }, {});
    return groups;
  }, [data == null ? void 0 : data.tripInfos, data == null ? void 0 : data.tabTitle]);
  return /* @__PURE__ */React16.createElement(EGDSLayoutGrid4, {
    autoRows: (data == null ? void 0 : data.tripInfos) && ((_a = data == null ? void 0 : data.tripInfos) == null ? void 0 : _a.length) > 1 ? [MinMax("24x", "48x")] : ["min-content"],
    "data-stid": "trip-category-grid"
  }, /* @__PURE__ */React16.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React16.createElement(EGDSScrollable, {
    direction: "vertical",
    "data-stid": "trip-scrollable-container"
  }, /* @__PURE__ */React16.createElement(EGDSSpacing6, {
    padding: {
      inlineend: "three"
    }
  }, groupedTrips ? /* @__PURE__ */React16.createElement("div", {
    "data-stid": "all-trips-container"
  }, Object.entries(groupedTrips).sort(([yearA], [yearB]) => Number(yearB) - Number(yearA)).map(([year, trips]) => {
    if (!(trips == null ? void 0 : trips.length)) {
      return null;
    }
    return /* @__PURE__ */React16.createElement(EGDSSpacing6, {
      key: year,
      padding: {
        blockend: "four"
      }
    }, /* @__PURE__ */React16.createElement(EGDSLayoutFlex6, {
      direction: "column",
      space: "three"
    }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(EGDSHeading3, {
      tag: "h3",
      size: 6,
      "data-stid": "trip-year-heading"
    }, year)), /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(EGDSLayoutGrid4, {
      columns: ["repeat(auto-fit, 327px)"],
      space: "small",
      "data-stid": `trip-grid-${year}`
    }, trips.map((trip, index) => trip ? /* @__PURE__ */React16.createElement(EGDSLayoutGridItem4, {
      key: `${year}-${index}`
    }, /* @__PURE__ */React16.createElement(HelpCenterTripInfoCard, {
      data: trip,
      openSheet,
      "data-stid": `trip-info-${year}-${index}`
    })) : null)))));
  })) :
  // Non-past trips regular grid
  /* @__PURE__ */
  React16.createElement("div", {
    "data-stid": "non-past-trips-section"
  }, /* @__PURE__ */React16.createElement(EGDSLayoutGrid4, {
    columns: ["repeat(auto-fit, 327px)"],
    space: "small",
    "data-stid": "trip-info-grid"
  }, (_b = data == null ? void 0 : data.tripInfos) == null ? void 0 : _b.map((ele, index) => /* @__PURE__ */React16.createElement("div", {
    "data-stid": "trip-info-overview",
    key: index
  }, /* @__PURE__ */React16.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React16.createElement(HelpCenterTripInfoCard, {
    data: ele,
    openSheet
  }))))))))));
};
TripCategoryPill.fragment = fragment8;
TripCategoryPill.displayName = "TripCategoryPill";

// src/trip/query/tripmtwo.tsx
var __Query2 = gql15`
  query HelpCenterTripQueryM2($context: ContextInput!) {
    helpCenterPersonalization(context: $context) {
      helpCenterTripView {
        trip {
          header
          emptyState {
            ...EmptyStateFragment
          }
          allTrips {
            ...TripCategoryPillFragment
          }
          goToTrips {
            ...GoToTripsFragment
          }
        }
      }
    }
  }
  ${TripCategoryPill.fragment}
  ${EmptyState.fragment}
  ${GoToTripsButton.fragment}
`;
var Tripmtwo = ({
  ssr = false
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E;
  const {
    context
  } = useBexApi2();
  const [selectedTabIndex, setSelectedTabIndex] = React17.useState(0);
  const [visible, setVisible] = React17.useState(false);
  const [bookingPayload, setBookingPayload] = useState({
    timePeriod: "",
    tripName: "",
    tripId: ""
  });
  const ref = React17.createRef();
  const handleTabSelect = React17.useCallback(index => {
    setSelectedTabIndex(index);
  }, []);
  const handleCardClick = (tripId, tripName, timePeriod) => {
    setBookingPayload({
      timePeriod,
      tripName,
      tripId
    });
    setVisible(true);
  };
  const onNavigationClick = () => {
    setVisible(!visible);
  };
  const getTripBookingView = () => {
    return /* @__PURE__ */React17.createElement(TripBookings, {
      bookingPayload,
      closeSideSheet: onNavigationClick
    });
  };
  const variables = {
    context
  };
  const {
    data,
    error,
    loading
  } = useQuery2(__Query2, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr
  });
  const isM2LandingPageEnabled = useExperiment2("Help_Center_Web_Landing_Page_UX_M2").exposure.bucket === 1;
  const renderSheet = isSmallView => {
    const commonContent = /* @__PURE__ */React17.createElement(EGDSSheetTransition, {
      isVisible: visible
    }, /* @__PURE__ */React17.createElement(EGDSSheet, {
      isVisible: visible,
      type: "side",
      triggerRef: ref,
      onDismiss: onNavigationClick,
      ariaLabel: bookingPayload.tripName
    }, /* @__PURE__ */React17.createElement(EGDSToolbar, {
      "data-testid": "close-sidesheet",
      navigationContent: {
        onClick: onNavigationClick,
        navIconLabel: isSmallView ? "Go back" : "Close Toolbar",
        navType: isSmallView ? "back" : void 0
      },
      toolbarTitle: isSmallView ? void 0 : bookingPayload.tripName,
      toolbarSubtitle: isSmallView ? void 0 : bookingPayload.timePeriod
    }), isSmallView && /* @__PURE__ */React17.createElement(EGDSSpacing7, {
      margin: {
        inlinestart: "six",
        inlineend: "six"
      }
    }, /* @__PURE__ */React17.createElement(EGDSLayoutFlex7, {
      direction: "column",
      space: "one"
    }, /* @__PURE__ */React17.createElement(EGDSHeading4, {
      tag: "h4",
      size: 4,
      typeStyle: {
        customStyle: "headline-large"
      }
    }, bookingPayload.tripName), /* @__PURE__ */React17.createElement(EGDSText4, {
      size: 300
    }, bookingPayload.timePeriod))), getTripBookingView()));
    return commonContent;
  };
  if (error) {
    return null;
  }
  if (!((_c = (_b = (_a = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _a.helpCenterTripView) == null ? void 0 : _b.trip) == null ? void 0 : _c.allTrips)) {
    return /* @__PURE__ */React17.createElement("div", {
      style: {
        marginBottom: isM2LandingPageEnabled ? "32px" : "0"
      }
    }, /* @__PURE__ */React17.createElement(Viewport, null, /* @__PURE__ */React17.createElement(ViewSmall, null, /* @__PURE__ */React17.createElement(EGDSHeading4, {
      "data-testid": "manage-heading",
      tag: "h2",
      align: "left",
      size: 5
    }, (_f = (_e = (_d = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _d.helpCenterTripView) == null ? void 0 : _e.trip) == null ? void 0 : _f.header)), /* @__PURE__ */React17.createElement(ViewMedium, null, /* @__PURE__ */React17.createElement(EGDSHeading4, {
      "data-testid": "manage-heading",
      tag: "h2",
      align: "left",
      size: 4,
      typeStyle: {
        customStyle: "headline-large"
      }
    }, (_i = (_h = (_g = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _g.helpCenterTripView) == null ? void 0 : _h.trip) == null ? void 0 : _i.header))), ((_l = (_k = (_j = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _j.helpCenterTripView) == null ? void 0 : _k.trip) == null ? void 0 : _l.emptyState) && /* @__PURE__ */React17.createElement(EmptyState, {
      data: data.helpCenterPersonalization.helpCenterTripView.trip.emptyState
    }));
  }
  if (loading) {
    return /* @__PURE__ */React17.createElement(loading_state_default, null);
  }
  return /* @__PURE__ */React17.createElement(React17.Fragment, null, ((_n = (_m = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _m.helpCenterTripView) == null ? void 0 : _n.trip) && /* @__PURE__ */React17.createElement(EGDSLayoutFlex7, {
    alignContent: "end",
    alignItems: "stretch",
    direction: "column",
    justifyContent: "start",
    space: "three"
  }, /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React17.createElement(Viewport, null, /* @__PURE__ */React17.createElement(ViewSmall, null, /* @__PURE__ */React17.createElement(EGDSHeading4, {
    "data-testid": "manage-heading",
    tag: "h2",
    align: "left",
    size: 5
  }, (_q = (_p = (_o = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _o.helpCenterTripView) == null ? void 0 : _p.trip) == null ? void 0 : _q.header)), /* @__PURE__ */React17.createElement(ViewMedium, null, /* @__PURE__ */React17.createElement(EGDSHeading4, {
    "data-testid": "manage-heading",
    tag: "h2",
    align: "left",
    size: 4,
    typeStyle: {
      customStyle: "headline-large"
    }
  }, (_t = (_s = (_r = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _r.helpCenterTripView) == null ? void 0 : _s.trip) == null ? void 0 : _t.header)))), /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React17.createElement(EGDSTabs, {
    "data-stid": "egds-tab-container",
    selectedTab: selectedTabIndex,
    onTabSelect: handleTabSelect,
    tabsType: EGDSTabsType.NATURAL,
    backgroundColor: EGDSTabsBackGroundColorType.PRIMARY
  }, (_x = (_w = (_v = (_u = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _u.helpCenterTripView) == null ? void 0 : _v.trip) == null ? void 0 : _w.allTrips) == null ? void 0 : _x.map((ele, index) => {
    var _a2;
    return /* @__PURE__ */React17.createElement(EGDSTab, {
      name: ele == null ? void 0 : ele.tabTitle,
      id: ele == null ? void 0 : ele.tabTitle,
      key: ele == null ? void 0 : ele.tabTitle,
      selected: selectedTabIndex === index,
      "aria-controls": `panel-${(_a2 = ele == null ? void 0 : ele.tabTitle) == null ? void 0 : _a2.toLowerCase()}`,
      "aria-selected": selectedTabIndex === index,
      role: "tab",
      targetURI: `panel-${index}`,
      onChange: (/* istanbul ignore next -- @preserve */
      () => handleTabSelect(index))
    });
  }))), /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem6, null, (_B = (_A = (_z = (_y = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _y.helpCenterTripView) == null ? void 0 : _z.trip) == null ? void 0 : _A.allTrips) == null ? void 0 : _B.map((cardcontent, tabSelected) => {
    var _a2, _b2;
    return selectedTabIndex === tabSelected && /* @__PURE__ */React17.createElement("div", {
      key: `panel-${cardcontent == null ? void 0 : cardcontent.tabTitle}`,
      role: "tabpanel",
      id: `panel-${(_a2 = cardcontent == null ? void 0 : cardcontent.tabTitle) == null ? void 0 : _a2.toLowerCase()}`,
      "aria-labelledby": `tab-${(_b2 = cardcontent == null ? void 0 : cardcontent.tabTitle) == null ? void 0 : _b2.toLowerCase()}`,
      tabIndex: 0
    }, /* @__PURE__ */React17.createElement(TripCategoryPill, {
      key: `${cardcontent.tabTitle}-${selectedTabIndex}`,
      data: cardcontent,
      selected: true,
      openSheet: handleCardClick
    }));
  })), ((_E = (_D = (_C = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _C.helpCenterTripView) == null ? void 0 : _D.trip) == null ? void 0 : _E.goToTrips) && /* @__PURE__ */React17.createElement(EGDSLayoutFlex7, {
    justifyContent: "start"
  }, /* @__PURE__ */React17.createElement(EGDSSpacing7, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React17.createElement(GoToTripsButton, {
    "data-testid": "go-to-trips",
    data: data.helpCenterPersonalization.helpCenterTripView.trip.goToTrips
  })))), /* @__PURE__ */React17.createElement(Viewport, null, /* @__PURE__ */React17.createElement(ViewSmall, null, renderSheet(true)), /* @__PURE__ */React17.createElement(ViewMedium, null, renderSheet(false))));
};
Tripmtwo.displayName = "sharedui-Trip";
export { TripBookings, Tripmtwo };
/* istanbul ignore file -- @preserve */
/* istanbul ignore next -- @preserve*/
/* istanbul ignore next -- @preserve */
//# sourceMappingURL=index.js.map